import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/ContractList.vue"),
    meta: {
      accessLevel: "super",
      title: "Contracts",
    },
    name: "contracts",
    path: "/contracts",
    props: (route) => typecastRouteProps(route),
  },
];
